/**
 * Enum utilizado para las convocatorias de tipo ingreso permanencia
 * y/o eméritos
 */
export enum TipoDocumentosFormalizacion {
  OFICIO = 'OFICIO',
  RECONOCIMIENTO = 'RECONOCIMIENTO',
  OFICIO_REVISORA = 'OFICIO_REVISORA',
  RECONOCIMIENTO_REVISORA = 'RECONOCIMIENTO_REVISORA',
  RECONOCIMIENTO_VIGENCIAS = 'RECONOCIMIENTO_VIGENCIAS',
  CONVENIO_VIGENCIAS = 'CONVENIO_VIGENCIAS',
  CONVENIO = 'CONVENIO',
  CONVENIO_REVISORA = 'CONVENIO_REVISORA',
  CONVENIO_AYUDANTES = 'CONVENIO_AYUDANTES',
  ANEXO_EXTRANJERAS = 'ANEXO_EXTRANJERAS',
  CONVENIO_EXTRANJERAS = 'CONVENIO_EXTRANJERAS',
  CAB_BEC_NAC_2025 = 'CAB_BEC_NAC_2025',
  ANEXO_BEC_BAC_2025 = 'ANEXO_BEC_BAC_2025',
  SOL_BEC_NAC_2025 = 'SOL_BEC_NAC_2025',
  CARTA_ISSSTE_2025 = 'CARTA_ISSSTE_2025',
}
